import { render, staticRenderFns } from "./CustomPeriodLimitFields.vue?vue&type=template&id=f95a8f34"
import script from "./CustomPeriodLimitFields.vue?vue&type=script&lang=js"
export * from "./CustomPeriodLimitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports